import Vue from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import router from "./router";
import { preloadImages } from "./utils/imagePreloader";

import FormBuilder from "lucien-form-builder";
Vue.use(FormBuilder);

import Dayjs from "vue-dayjs";
Vue.use(Dayjs);

import { Simplert } from "vue2-simplert-plugin";
import "vue2-simplert-plugin/dist/vue2-simplert-plugin.min.css";

Vue.use(Simplert);

const pinia = createPinia();
Vue.use(pinia);

import { InlineSvgPlugin } from "vue-inline-svg";
Vue.use(InlineSvgPlugin);

import "@fortawesome/fontawesome-free/css/all.css";
import "animate.css";
import "@/assets/style/style.scss";

Vue.config.productionTip = false;

// Préchargement des images avant le montage de l'application
preloadImages()
  .then(() => {
    console.log("Toutes les images ont été préchargées avec succès");
  })
  .catch((error) => {
    console.error("Erreur lors du préchargement des images:", error);
  })
  .finally(() => {
    new Vue({
      router,
      render: (h) => h(App),
    }).$mount("#app");
  });
